module.exports = __webpack_public_path__ + "media/newstyle/images/icon-amazon-e7d431dfb0ac84f0165139807401fc7f.svg";